import { Lookup } from "devextreme-react";
import { MutableRefObject, useEffect, useMemo, useRef } from "react";
import { getCompanySearchDataSource } from "@service/company/company-service";

export const BrokerageEditComponent = (props: any, dataGridRef: MutableRefObject<any>) => {
  const lookupRef = useRef<Lookup>(null);

  useEffect(() => {
    lookupRef.current.instance.open();
  }, []);
  const handleValueChanged = (e: any) => {
    const { data } = props;
    data.setValue(e.value);
    dataGridRef.current.instance.saveEditData();
  };

  const itemComponent = ({ data: item }: any) => {
    if (item) {
      let companyName = "";
      let ceoName = "";
      let address = "";
      !!item?.companyName ? (companyName = `${item.companyName}`) : "";
      !!item?.ceoName ? (ceoName = `/${item.ceoName}`) : "";
      !!item?.address ? (address = `/${item.address.district_1} ${item.address.district_2}`) : "";
      return <div>{`${companyName}(${item.id})${ceoName}${address}`}</div>;
    } else {
      return <div></div>;
    }
  };
  const companySearchDataSource = useMemo(() => {
    return getCompanySearchDataSource();
  }, []);
  return (
    <Lookup
      ref={lookupRef}
      dataSource={companySearchDataSource}
      minSearchLength={1}
      showClearButton={false}
      itemComponent={itemComponent}
      searchPlaceholder="대표 상호명 및 대표자로 검색"
      searchExpr={["id", "companyName", "ceoName"]}
      searchMode={"contains"}
      value={props.data.value?.id}
      width="24rem"
      onValueChanged={handleValueChanged}
    />
  );
};
